import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=61dad562&scoped=true"
import script from "./WarningIcon.vue?vue&type=script&lang=js"
export * from "./WarningIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dad562",
  null
  
)

export default component.exports